import { PlusOutlined } from '@ant-design/icons';
import { UIView } from '@uirouter/react';
import { Button } from 'antd';
import { observer } from 'mobx-react-lite';
import { FormattedMessage } from 'react-intl';

import { Table } from '@/components/table';
import { PERMISSION_CREATE, PERMISSION_OBJ_USER } from '@/constants/permissions';
import { withPermissions } from '@/hocs/permission';
import { rolesStore, usersStore } from '@/stores';
import { useMassUpdateCashedStores } from '@/utils/store';

import { columns } from './setup';

const users = usersStore;
const roles = rolesStore;

const CreateButton = withPermissions([[PERMISSION_OBJ_USER, PERMISSION_CREATE]])(({ onClick }: any) => {
  return (
    <Button onClick={onClick} type="primary" icon={<PlusOutlined />}>
      <FormattedMessage id="users.add-new" />
    </Button>
  );
});

export const Users = observer(({ transition }: any) => {
  const items = users.items;

  useMassUpdateCashedStores([users, roles]);

  const onAdd = () => {
    transition.router.stateService.go('base-layout.users.create');
  };

  return (
    <>
      <CreateButton onClick={onAdd} />
      <Table rowKey="id" columns={columns} dataSource={[...items]} store={users} />
      <UIView />
    </>
  );
});
